import { DrawerMenuIconType, DrawerMenuItem } from './drawerMenuSlice';

export const restaurantDrawerMenu: (
  restaurantId: string
) => DrawerMenuItem[] = (restaurantId) => [
  {
    title: 'restaurant.details.links.title.order',
    path: `/manager/restaurants/${restaurantId}/orders`,
    icon: DrawerMenuIconType.Orders,
  },
  {
    title: 'biller.title',
    path: `/manager/restaurants/${restaurantId}/biller`,
    icon: DrawerMenuIconType.Receipt,
  },
  {
    title: 'restaurant.details.links.title.kitchen',
    path: `/manager/restaurants/${restaurantId}/kitchens`,
    icon: DrawerMenuIconType.Kitchens,
  },
  {
    title: 'restaurant.details.links.title.menu',
    path: `/manager/restaurants/${restaurantId}/menus`,
    icon: DrawerMenuIconType.Menus,
  },
  {
    title: 'restaurant.details.links.title.table',
    path: `/manager/restaurants/${restaurantId}/restaurant-tables`,
    icon: DrawerMenuIconType.RestaurantTables,
  },
  {
    title: 'restaurant.details.links.title.meal-item',
    path: `/manager/restaurants/${restaurantId}/meal-items`,
    icon: DrawerMenuIconType.MealItems,
  },
  {
    title: 'restaurant.details.links.title.customization',
    path: `/manager/restaurants/${restaurantId}/meal-item-customizations`,
    icon: DrawerMenuIconType.Customizations,
  },
  {
    title: 'restaurant.details.links.title.user',
    path: `/manager/restaurants/${restaurantId}/restaurant-users`,
    icon: DrawerMenuIconType.RestaurantUsers,
  },
  {
    title: 'restaurant.settings.title',
    path: `/manager/restaurants/${restaurantId}/settings`,
    icon: DrawerMenuIconType.Settings,
  },
];

export const kitchenStaffDrawerMenu: (
  restaurantId: string,
  kitchenId: string
) => DrawerMenuItem[] = (restaurantId, kitchenId) => [
  {
    title: 'restaurant.details.links.title.order',
    path: `/kitchen-staff/restaurants/${restaurantId}/kitchens/${kitchenId}/orders`,
    icon: DrawerMenuIconType.Orders,
  },
  {
    title: 'restaurant.details.links.title.meal-item',
    path: `/kitchen-staff/restaurants/${restaurantId}/kitchens/${kitchenId}/meal-items`,
    icon: DrawerMenuIconType.MealItems,
  },
];

export const restaurantWaiterDrawerMenu: (
  restaurantId: string
) => DrawerMenuItem[] = (restaurantId) => [
  {
    title: 'restaurant.details.links.title.order',
    path: `/restaurant-waiter/restaurants/${restaurantId}/orders`,
    icon: DrawerMenuIconType.Orders,
  },
  {
    title: 'restaurant.details.links.title.table',
    path: `/restaurant-waiter/restaurants/${restaurantId}/tables`,
    icon: DrawerMenuIconType.RestaurantTables,
  },
  {
    title: 'biller.title',
    path: `/restaurant-waiter/restaurants/${restaurantId}/biller`,
    icon: DrawerMenuIconType.Receipt,
  },
];
